import { ref } from 'vue'
export default {
    name: 'SortDropdown',
    props: {
        config: {
            type: Object,
            required: true
        },
        guid: {
            type: String,
            required: true
        },
        sortingHandler: {
            type: Function,
            required: true
        }
    },
    setup() {
        const sortingValue = ref('')

        return {
            sortingValue
        }
    }
}
